import { createContext } from 'react';

const Geotab = createContext();

export default Geotab;
